import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const UserVerificationComponent = React.lazy(() => import("../Components/RootComponents/UserVerificationComponent"));
const UserVerificationPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <UserVerificationComponent />
      </Suspense>
    </Fragment>
  );
};

export default UserVerificationPage;
